<ion-header [translucent]="false">
  <ion-toolbar>    
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <img src="../../../../../assets/images/Logo_TELAR.ai.svg" alt="Logo">
    <div *ngIf="!hideUserInfo" slot="end" class="user-info px-2">

      <ion-chip id="click-trigger">
        <ion-avatar>
          <img alt="Silhouette of a person's head" [src]="'https://ui-avatars.com/api/?rounded=true&size=35&name=' + user?.displayName + '&background=3D4C86&color=fff'" />
        </ion-avatar>
        <ion-label>{{organization}}</ion-label>
        <ion-icon size="small" name="caret-down"></ion-icon>
      </ion-chip>

    </div>
  </ion-toolbar>
</ion-header>



<ion-popover trigger="click-trigger" triggerAction="click" [dismissOnSelect]="true">
  <ng-template>
    <ion-content>
   <div class="popover-content">
  
      <ion-item lines="full">
        <ion-label>
          {{organization}}
          <p class="user-email">{{user?.email}}</p>
        </ion-label>
        <ion-icon slot="end" color="success" name="checkmark-circle"></ion-icon>
      </ion-item>
    <div class="divider"></div>

    <ion-button fill="outline" shape="round" size="small" class="m-3" (click)="changeOrganization()">
      <ion-icon name="sync-outline" slot="start"></ion-icon>
      <ion-text class="button-text">Cambiar empresa</ion-text>
      
    </ion-button>
   </div>
    </ion-content>
  </ng-template>
</ion-popover>
